import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { captureException } from "@sentry/react";
import { IPlan } from "../../../../common/types";
import { showNotification } from "../../notification/actions";
import { IStateTree } from "../../interfaces";

import { ENABLE_EXPERIENCE_REQUEST, ENABLE_EXPERIENCE_SUCCESS, ENABLE_EXPERIENCE_FAILURE } from "../types";
import { PlanActionTypes } from "../models/planActions";

export default () => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: ENABLE_EXPERIENCE_REQUEST,
    });
    try {
        await api.post("/enable-experience", { planId: (getState().plan as IPlan)._id });
        dispatch({
            type: ENABLE_EXPERIENCE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ENABLE_EXPERIENCE_FAILURE,
        })
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};